// Rich display blocks dispatcher.
//
// Consumed (later, in ticket W2) by transport.js / animation.js: when a bot
// response carries a top-level `blocks` array, the caller invokes
// `renderBlocks(blocks, container, ctx)` and each block is rendered below
// the conversational text bubble.
//
// Each renderer is pure: given (block, ctx) it returns an HTMLElement with
// any internal listeners already attached. Unknown block types are skipped
// with a console warning (never throw — a malformed block must not break
// the rest of the message).

import { renderTable } from './table.js';
import { renderLinks } from './links.js';
import { renderGallery } from './gallery.js';
import { renderPropertyCarousel } from './property-carousel.js';

const RENDERERS = {
  table: renderTable,
  links: renderLinks,
  gallery: renderGallery,
  property_carousel: renderPropertyCarousel,
};

export function renderBlocks(blocks, container, ctx = {}) {
  if (!Array.isArray(blocks) || !container) return;
  for (const block of blocks) {
    if (!block || typeof block.type !== 'string') continue;
    const renderer = RENDERERS[block.type];
    if (!renderer) {
      console.warn('[chatyx] Unknown rich-display block type:', block.type);
      continue;
    }
    try {
      const el = renderer(block, ctx);
      if (el instanceof HTMLElement) container.appendChild(el);
    } catch (e) {
      console.error('[chatyx] Block render error for type', block.type, e);
    }
  }
}

export { renderTable, renderLinks, renderGallery, renderPropertyCarousel };
